module.exports = __webpack_public_path__ + "img/bg-pattern-polarize.f3ebc3d1.png";